'use strict';(function globalNavJs() {
  var jdIdGlobalModalBg = '[data-js="js-modal-bg"]';
  var jsIdGlobalNav = '[data-js="js-g-nav"]';
  var jsIdGlobalNavLi = '[data-js="js-g-nav__bar-li"]';
  var jsIdGlobalNavButton = '[data-js="js-g-nav__bar-btn"]';
  var jsIdMegaMenu = '.c-mega';
  var jsIdMegaMenuClose = '[data-js="js-c-mega__close"]';
  var jsIdMegaMenuSection = '[data-js="js-c-mega__section"]';
  var jsIdMegaMenuLi = '[data-js="js-c-mega__li"]';
  var jsIdMegaMenuMobilePlus = '[data-js="js-c-mega__mobile-btn"]';
  var jsIdMobileMainMenu = '[data-js="js-btn-menu--close"]';
  var jsIdMobileHamburg = '[data-js="js-btn-menu--hamburg"]';
  var jsIdMobileAccount = '[data-js="js-btn-menu--account"]';
  var jsIdMobileAccountSection = '[data-js="js-account-section"]';
  var genericActivationCssClass = 'is-active';
  var cssSubmenuActivationClass = 'submenu-is-active';
  var cssActiveMobileButtonClass = 'g-nav__mobile-btn--active';

  function initCheckMobile() {
    var _isMobile = false;
    return function checkForMobile() {
      if (!_isMobile && window.innerWidth <= 1024) {
        _isMobile = true;
      } else if (_isMobile && window.innerWidth > 1024) {
        _isMobile = false;
      }
      return _isMobile;
    };
  }

  var getIsMobile = initCheckMobile();

  function utilAddClickListenerGroup(elementsGroup, handler, specialLoopFunction) {
    for (var i = 0; i < elementsGroup.length; i++) {
      elementsGroup[i].addEventListener('click', handler);
      specialLoopFunction && specialLoopFunction(elementsGroup[i]);
    }
  }

  function addDataJsForCMega(item) {
    if (!item.classList.contains('c-mega')) return;
    item.setAttribute('data-js', 'js-c-mega');
  }

  function initActivationItem(item) {
    if (!item) return {};

    addDataJsForCMega(item);

    function parseItemForSpecificActivationClass() {
      var datajs = item.dataset.js;
      var lookingForString = 'js-';
      var doesStartsWith = datajs.substring(0, lookingForString.length) === lookingForString;
      var selectorBasedActivationClass = datajs && doesStartsWith && datajs.slice(3).concat('--is-active');
      return selectorBasedActivationClass || genericActivationCssClass;
    }

    var cssActivationClass = parseItemForSpecificActivationClass();

    function setAriaExpanded(val) {
      if (item.hasAttribute('aria-expanded')) item.setAttribute('aria-expanded', val);
    }

    function scrollIntoViewOnMobile() {
      if (buttonMobileMainMenu && getIsMobile()) {
        buttonMobileMainMenu.scrollIntoView();
      }
    }

    function _activate() {
      item.classList.add(cssActivationClass);
      scrollIntoViewOnMobile();
      setAriaExpanded(true);
    }

    function _deactivate() {
      item.classList.remove(cssActivationClass);
      setAriaExpanded(false);
    }

    return {
      element: item,
      activate: _activate,
      deactivate: _deactivate };

  }

  function initToggleActivationItems(controller, parentController) {
    return function toggleActivationItems(forceDeactivate) {
      for (var i = 0; i < controller.activateItems.length; i++) {
        var activateItem = controller.activateItems[i];
        if (controller.isActive || forceDeactivate) {
          activateItem.deactivate();
        } else {
          activateItem.activate();
        }
      }

      if (forceDeactivate) {
        controller.isActive = false;
        return;
      }

      controller.isActive = !controller.isActive;
      if (parentController) {
        parentController.isSubMenuActive = controller.isActive;
        if (controller.isActive) {
          parentController.activateButton.classList.add(cssSubmenuActivationClass);
        } else {
          parentController.activateButton.classList.remove(cssSubmenuActivationClass);
        }
      }
    };
  }

  //-----------------------------------------------------------------------------------
  var mainMenuControllers = [];
  var gNavModalBg = document.querySelector(jdIdGlobalModalBg);
  var gnav = document.querySelector(jsIdGlobalNav);
  if (!gnav) return;
  var buttonMobileMainMenu = gnav.querySelector(jsIdMobileMainMenu);
  var buttonMobileHamburg = gnav.querySelector(jsIdMobileHamburg);
  var buttonMobileAccount = gnav.querySelector(jsIdMobileAccount);
  var allMobileButtons = gnav.querySelectorAll('.g-nav__mobile-btn');
  var sectionMobileAccount = gnav.querySelector(jsIdMobileAccountSection);
  var buttonGroupMegaMenuClose = gnav.querySelectorAll(jsIdMegaMenuClose);

  var hasEmptySelectAccount = !sectionMobileAccount || sectionMobileAccount.querySelectorAll('.r-btn').length === 0;
  var hasEmptyNavigation = !gnav.querySelector('.g-nav__bar');
  var aigNav = initActivationItem(gnav);
  var primaryNavController = { toggle: function toggle() {} };


  function deactiveAllMobileBtns() {
    for (var i = 0; i < allMobileButtons.length; i++) {
      var mobileMenuBtn = allMobileButtons[i];
      mobileMenuBtn.classList.remove(cssActiveMobileButtonClass);
    }
  }

  function closeAllMenus() {
    for (var i = 0; i < mainMenuControllers.length; i++) {
      var controller = mainMenuControllers[i];
      controller.deactivateChildren();
      controller.toggle(true);
    }
    sectionMobileAccount && sectionMobileAccount.classList.remove('is-open');
    gnav.classList.remove('is-open');
    gnav.classList.remove('is-open--account');
  }

  //-----------------------------------------------------------------------------------
  //-----------------------------------------------------------------------------------
  function toggleMobileModalBackground() {
    var isMobile = getIsMobile();
    if (isMobile) {
      if (gnav.classList.contains('is-open') || gnav.classList.contains('is-open--account')) {
        gNavModalBg.classList.add(genericActivationCssClass);
        return;
      }
    }
    gNavModalBg.classList.remove(genericActivationCssClass);
  }

  function mobileToggleMenu(curTarget, activationContainer, parentActivationClass) {
    closeAllMenus();
    primaryNavController.toggle(true);
    if (curTarget.classList.contains(cssActiveMobileButtonClass)) {
      curTarget.classList.remove(cssActiveMobileButtonClass);
    } else {
      deactiveAllMobileBtns();
      activationContainer.classList.add(parentActivationClass);
      curTarget.classList.add(cssActiveMobileButtonClass);
    }
    toggleMobileModalBackground();
  }

  function handlerToggleHamburgMenu(e) {
    mobileToggleMenu(e.target, gnav, 'is-open');
  }

  function handlerMobileAccountMenu(e) {
    mobileToggleMenu(e.target, gnav, 'is-open--account');
  }

  function initButtonListeners() {
    if (hasEmptySelectAccount) {
      buttonMobileAccount.classList.add('u-display--none');
    } else {
      buttonMobileAccount.addEventListener('click', handlerMobileAccountMenu);
    }

    if (hasEmptyNavigation) {
      buttonMobileHamburg.classList.add('u-display--none');
    } else {
      buttonMobileHamburg.addEventListener('click', handlerToggleHamburgMenu);
    }
  }

  initButtonListeners();
  //-----------------------------------------------------------------------------------
  //-----------------------------------------------------------------------------------
  function handlerWindowResize() {
    toggleMobileModalBackground();
  }

  function handlerDocumentClose(e) {
    var ifClickAndNotMenu = e.type === 'click' && !gnav.contains(e.target);
    var ifKeyAndEsc = e.type === 'keydown' && e.keyCode === 27;
    if (ifClickAndNotMenu || ifKeyAndEsc) {
      closeAllMenus();
      deactiveAllMobileBtns();
      toggleMobileModalBackground();
    }
  }

  function initDocumentListeners() {
    window.addEventListener('resize', handlerWindowResize);
    document.addEventListener('click', handlerDocumentClose);
    document.addEventListener('keydown', handlerDocumentClose);
  }

  //-----------------------------------------------------------------------------------
  //-----------------------------------------------------------------------------------

  function handlerBackToMobileMainMenu(e) {
    for (var i = 0; i < mainMenuControllers.length; i++) {
      var controller = mainMenuControllers[i];
      //turn off everything this is active and wasn't clicked
      if (controller.isActive && !controller.isClicked) {
        controller.deactivateChildren();
        controller.toggle();
      }
      controller.isClicked = false;
    }
  }

  function initMobileNavigationListeners() {
    buttonMobileMainMenu.addEventListener('click', handlerBackToMobileMainMenu);
    utilAddClickListenerGroup(buttonGroupMegaMenuClose, handlerBackToMobileMainMenu);
  }

  function deactivateChildren(controller) {
    return function deactivateSubMenu() {
      for (var i = 0; i < controller.sections.length; i++) {
        controller.sections[i].deactivate();
      }
    };
  }

  var nodesGlobalNavLis = gnav.querySelectorAll(jsIdGlobalNavLi);
  var arrGlobalNavLis = Array.prototype.slice.call(nodesGlobalNavLis);

  function initGlobalNavHandler(mainMenuController) {
    return function handlerGlobalNavButton(e) {
      if (mainMenuController.isActive && !mainMenuController.isSubMenuActive) {
        mainMenuController.toggle();
        return;
      }

      if (mainMenuController.isSubMenuActive) {
        mainMenuController.deactivateChildren();
      } else {
        handlerBackToMobileMainMenu(e);
        mainMenuController.toggle();
      }
    };
  }

  function initSubmenuClickHandler(mobileSectionController) {
    return function handlerSubMenuClick(e) {
      mobileSectionController.toggle();
    };
  }

  function initMobileSectionDeactivate(mobileSectionController) {
    return function mobileSectionDeactivate() {
      mobileSectionController.isActive && mobileSectionController.toggle();
    };
  }

  function initPrimaryNavFix() {
    var elGlobalNavPrimaryNav = document.getElementById('primary-nav');
    if (!elGlobalNavPrimaryNav) return;
    var elPrimaryNavOverlay = document.getElementById('overlay');

    function globalSecondaryNavFixController() {
      var elSubnavToggle = document.getElementById('subnav-toggle');
      var elSubnav = document.querySelector('.sub-navigation');

      if (elSubnavToggle) {
        elSubnavToggle.classList.add('g-secondary-nav');
        elSubnavToggle.classList.remove('active');
      }

      function _closeSecondaryNav() {
        if (elSubnavToggle && elSubnavToggle.classList.contains('active')) {
          elSubnavToggle.querySelector('use').setAttribute('xlink:href', '#gmd-ic-add-24px');
          elSubnavToggle.classList.remove('active');
          elSubnav && elSubnav.classList.remove('active');
        }
      }

      return {
        closeSecondaryNav: _closeSecondaryNav };

    }

    function globalPrimaryNavFixController() {
      var elPrimaryNavToggle = document.querySelector('.g-primary-nav .nav-menu .nav-item:first-child a');
      if (!elPrimaryNavToggle) return;
      var elNavItemIcon = elPrimaryNavToggle.querySelector('.nav-item__icon');
      var _secondaryNavController = globalSecondaryNavFixController();

      function _cloneNavItemIconForMenuToggle(parent) {
        var elNavItemIconToClone = elGlobalNavPrimaryNav.querySelector('.nav-item__icon');
        if (elNavItemIconToClone) {
          parent.appendChild(elNavItemIconToClone.cloneNode(true));
        } else {
          parent.classList.add('missing-icon');
        }
      }

      function swapAddRemoveIcon(isActive) {
        if (!elNavItemIcon) {
          elNavItemIcon = elPrimaryNavToggle.querySelector('.nav-item__icon');
        }
        if (!elNavItemIcon) return;
        var _icon = isActive ? '#gmd-ic-add-24px' : '#gmd-ic-remove-24px';
        elNavItemIcon.querySelector('use').setAttribute('xlink:href', _icon);
      }

      function toggleLegacyMenus(isActive) {
        function _toggleActive(element) {
          if (!element) return;
          if (isActive) {
            element.classList.remove('active');
          } else {
            element.classList.add('active');
          }
        }

        _toggleActive(elGlobalNavPrimaryNav);
        _toggleActive(elPrimaryNavOverlay);
        swapAddRemoveIcon(isActive);
        _secondaryNavController.closeSecondaryNav();
      }

      function primaryNavToggleHandler(event) {
        event.preventDefault();
        var isActive = elGlobalNavPrimaryNav.classList.contains('active');
        toggleLegacyMenus(isActive);
      }

      primaryNavController.toggle = toggleLegacyMenus;
      _cloneNavItemIconForMenuToggle(elPrimaryNavToggle);
      elPrimaryNavToggle.addEventListener('click', primaryNavToggleHandler);
    }

    document.addEventListener('DOMContentLoaded', globalPrimaryNavFixController);
  }


  function initNavigation() {
    initPrimaryNavFix();
    if (hasEmptyNavigation) return;
    initDocumentListeners();
    initMobileNavigationListeners();
    getIsMobile();
  }

  initNavigation();

  function initMenuController(gNavLi) {
    var gNavButton = gNavLi.querySelector(jsIdGlobalNavButton);
    var gNavMegaMenu = gNavLi.querySelector(jsIdMegaMenu);
    //short circuit
    if (!gNavButton || !gNavMegaMenu) return;

    var aigNavLi = initActivationItem(gNavLi);
    var aigNavButton = initActivationItem(gNavButton);
    var aigNavMegaMenu = initActivationItem(gNavMegaMenu);

    var mainMenuController = {
      activateButton: gNavButton,
      activateItems: [aigNav, aigNavLi, aigNavButton],
      isActive: false,
      isSubMenuActive: false,
      isClicked: false,
      sections: [] };


    mainMenuController.toggle = initToggleActivationItems(mainMenuController);
    mainMenuController.deactivateChildren = deactivateChildren(mainMenuController);

    gNavButton.addEventListener('click', initGlobalNavHandler(mainMenuController));

    var arrMegaMenuSection = Array.prototype.slice.call(gNavMegaMenu.querySelectorAll(jsIdMegaMenuSection));
    for (var msi = 0; msi < arrMegaMenuSection.length; msi++) {
      var menuSection = arrMegaMenuSection[msi];
      var aiMenuSection = initActivationItem(menuSection);

      var arrMegaMenuLi = Array.prototype.slice.call(menuSection.querySelectorAll(jsIdMegaMenuLi));
      for (var mmli = 0; mmli < arrMegaMenuLi.length; mmli++) {
        var mobileSubMenuLi = arrMegaMenuLi[mmli];
        var buttonMobilePlus = mobileSubMenuLi.querySelector(jsIdMegaMenuMobilePlus);
        var aiButtonMobilePlus = initActivationItem(buttonMobilePlus);
        var aiMobileSubMenuLi = initActivationItem(mobileSubMenuLi);

        var mobileSectionController = {
          activateButton: buttonMobilePlus,
          activateItems: [aigNavMegaMenu, aiButtonMobilePlus, aiMenuSection, aiMobileSubMenuLi],
          isActive: false };


        mobileSectionController.toggle = initToggleActivationItems(mobileSectionController, mainMenuController);
        mobileSectionController.deactivate = initMobileSectionDeactivate(mobileSectionController);
        mobileSectionController.activateButton.addEventListener('click', initSubmenuClickHandler(mobileSectionController));

        mainMenuController.sections.push(mobileSectionController);
      }
    }

    mainMenuControllers.push(mainMenuController);
  }

  for (var gli = 0; gli < arrGlobalNavLis.length; gli++) {
    var gNavLi = arrGlobalNavLis[gli];
    initMenuController(gNavLi);
  }
})();